import { render, staticRenderFns } from "./WarnRecordView.vue?vue&type=template&id=08ff23de&scoped=true&"
import script from "./WarnRecordView.vue?vue&type=script&lang=js&"
export * from "./WarnRecordView.vue?vue&type=script&lang=js&"
import style0 from "./WarnRecordView.vue?vue&type=style&index=0&id=08ff23de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff23de",
  null
  
)

export default component.exports